export default "__VITE_ASSET__2eeaf559__"